import type { ContentItem, ArticleData } from '@/types';

export const ARTICLE_DATA: Record<string, ArticleData> = {
  liulangdiqiu3: {
    id: 1,
    title: '流浪地球3',
    slug: 'liulangdiqiu3',
    category: '电影',
    categorySlug: 'dianying',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20epic%20scene%2C%20giant%20earth%20with%20engine%20thrusters%20in%20deep%20space%2C%20dramatic%20cosmic%20background%2C%20cinematic%20lighting%2C%20no%20text&width=1200&height=600&seq=article-1&orientation=landscape',
    rating: 9.5,
    year: 2026,
    description: '太阳急速老化，持续膨胀。一百年后，太阳将膨胀到地球轨道，人类面临灭顶之灾。联合政府决定启动"流浪地球计划"——在地球表面建造上万座行星发动机，推动地球逃离太阳系，前往4.2光年外的新家园。然而，在这场跨越2500年的漫长旅程中，未知的宇宙威胁正在悄然逼近...',
    tags: ['科幻', '灾难', '冒险', '吴京', '刘德华'],
    updateInfo: '高清完整版',
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健', '沙溢', '宁理'],
    duration: '148分钟',
    publishDate: '2026-02-10',
    content: '流浪地球3延续了前作的世界观设定，在地球逃离太阳系的漫长旅程中，人类面临着前所未有的挑战。本作将目光投向更遥远的宇宙深处，地球舰队在穿越奥尔特星云时，遭遇了未知的外星文明信号。联合政府内部出现了分裂——是继续前进寻找新家园，还是回应外星文明的召唤？\n\n影片在视觉特效上实现了质的飞跃，行星发动机的细节刻画达到国际一流水平。吴京饰演的刘培强在第二部中牺牲后，本作以全息影像的方式回归，成为其子刘启的精神指引。刘德华饰演的图恒宇角色得到进一步深化，数字生命计划与人类命运的选择构成影片的核心主题之一。\n\n影片探讨了"何为人类""何为家园"的终极命题，在硬科幻的外壳下，包裹着温暖的人文内核。',
  },
  qingyunian3: {
    id: 2,
    title: '庆余年3',
    slug: 'qingyunian3',
    category: '电视剧',
    categorySlug: 'dianshiju',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20scene%2C%20ancient%20palace%20courtyard%20with%20scholar%20in%20robes%2C%20dramatic%20shadows%2C%20misty%20atmosphere%2C%20cinematic%2C%20no%20text&width=1200&height=600&seq=article-2&orientation=landscape',
    rating: 9.2,
    year: 2026,
    description: '范闲在大东山事件后，身世之谜逐渐揭开。各方势力暗流涌动，京都风云再起。庆帝的真实意图、陈萍萍的暗中布局、长公主的野心——一切都指向一个惊天的秘密...',
    tags: ['古装', '权谋', '剧情', '张若昀', '陈道明'],
    updateInfo: '更新至第36集',
    director: '孙皓',
    cast: ['张若昀', '陈道明', '吴刚', '李沁', '辛芷蕾'],
    duration: '45分钟/集',
    publishDate: '2026-05-15',
    content: '庆余年第三季作为整部系列的高潮篇章，将揭开范闲身世的终极秘密。大东山事件后，庆帝对范闲的态度发生了微妙变化，北齐、东夷城、南庆三足鼎立的格局也在悄然改变。\n\n本季重点刻画范闲在得知自己真实身份后的心理转变，他不再只是那个想要逍遥人间的少年，而是开始认真思考自己在这个世界中的位置和责任。陈萍萍与庆帝之间的恩怨、叶轻眉之死的真相，都将在本季得到完整呈现。\n\n在制作层面，本季的场景更加宏大，大东山之战的特效场面堪称国产剧集新标杆。演员阵容再度升级，新加入的实力派演员为剧情增添了更多看点。',
  },
  kuangbiao2: {
    id: 3,
    title: '狂飙2：暗流',
    slug: 'kuangbiao2',
    category: '电视剧',
    categorySlug: 'dianshiju',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20scene%2C%20modern%20city%20night%20with%20neon%20lights%20on%20wet%20street%2C%20mysterious%20detectives%2C%20intense%20atmosphere%2C%20no%20text&width=1200&height=600&seq=article-3&orientation=landscape',
    rating: 9.0,
    year: 2026,
    description: '扫黑除恶专项斗争持续深入，新一季聚焦金融犯罪与网络黑产背后的保护伞。新一代专案组成员接过安欣的旗帜，向更隐蔽的犯罪集团发起挑战...',
    tags: ['犯罪', '悬疑', '剧情', '张译', '王骁'],
    updateInfo: '更新至第24集',
    director: '徐纪周',
    cast: ['张译', '王骁', '高叶', '林家川', '冯兵'],
    duration: '45分钟/集',
    publishDate: '2026-03-20',
    content: '狂飙2：暗流将故事时间线设置在首部的五年之后。安欣虽然已经退休，但他培养的新一代专案组成员正在面临更为复杂的犯罪形势。金融诈骗、网络黑产、跨境洗钱——犯罪手段的升级给侦破工作带来了前所未有的挑战。\n\n本季的核心案件围绕一个名为"暗网"的地下金融网络展开，涉及金额高达数百亿元。专案组在调查过程中发现，这个网络的背后有着错综复杂的保护伞。王骁饰演的新任专案组长延续了安欣式的执着，在法与情的边界上艰难前行。\n\n剧情节奏紧凑，每集都有高能反转。对当下社会热点问题——网络诈骗、数据安全、金融监管等进行了深度呈现，兼具社会意义与娱乐价值。',
  },
};

export const RELATED_ARTICLES: Record<string, ContentItem[]> = {
  liulangdiqiu3: [
    {
      id: 4, title: '封神第二部', slug: 'fengshen2', category: '电影', categorySlug: 'dianying',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20movie%20poster%2C%20warriors%20in%20armor%20with%20magical%20weapons%2C%20epic%20battle%2C%20no%20text&width=600&height=800&seq=related-1a&orientation=portrait',
      rating: 8.8, year: 2026, description: '殷商大军压境，封神大战一触即发...', tags: ['奇幻', '动作', '神话'], updateInfo: '高清完整版',
    },
    {
      id: 7, title: '三体：黑暗森林', slug: 'santi2', category: '电视剧', categorySlug: 'dianshiju',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20drama%20poster%2C%20cosmic%20scene%20with%20three%20suns%2C%20dark%20space%2C%20minimal%2C%20no%20text&width=600&height=800&seq=related-1b&orientation=portrait',
      rating: 8.9, year: 2026, description: '面壁计划启动，跨越光年的智慧博弈...', tags: ['科幻', '悬疑', '剧情'], updateInfo: '更新至第12集',
    },
    {
      id: 8, title: '孤注一掷2', slug: 'guzhuyizhi2', category: '电影', categorySlug: 'dianying',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20movie%20poster%2C%20person%20behind%20bars%20in%20dark%20room%2C%20suspenseful%2C%20no%20text&width=600&height=800&seq=related-1c&orientation=portrait',
      rating: 8.7, year: 2026, description: '境外诈骗团伙死灰复燃，AI技术成为新威胁...', tags: ['犯罪', '剧情', '社会'], updateInfo: '高清完整版',
    },
    {
      id: 6, title: '哪吒之魔童闹海', slug: 'nezha2', category: '动漫', categorySlug: 'dongman',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%2C%20boy%20with%20fire%20on%20dragon%2C%20ocean%20storm%2C%20vibrant%2C%20no%20text&width=600&height=800&seq=related-1d&orientation=portrait',
      rating: 9.3, year: 2026, description: '哪吒与敖丙在天劫之后，更大的危机在海面下酝酿...', tags: ['动画', '奇幻', '冒险'], updateInfo: '高清完整版',
    },
  ],
  qingyunian3: [
    {
      id: 10, title: '大奉打更人', slug: 'dafengdagengren', category: '电视剧', categorySlug: 'dianshiju',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20drama%20poster%2C%20warrior%20with%20sword%20under%20moon%2C%20mystical%2C%20dark%20forest%2C%20no%20text&width=600&height=800&seq=related-2a&orientation=portrait',
      rating: 8.6, year: 2026, description: '许七安穿越到大奉王朝的奇幻冒险...', tags: ['古装', '奇幻', '喜剧'], updateInfo: '更新至第28集',
    },
    {
      id: 15, title: '琅琊榜', slug: 'langyabang', category: '电视剧', categorySlug: 'dianshiju',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%2C%20scholar%20in%20white%20on%20mountain%2C%20misty%2C%20classical%2C%20no%20text&width=600&height=800&seq=related-2b&orientation=portrait',
      rating: 9.3, year: 2015, description: '十二年后林殊改头换面，重返帝都昭雪冤案...', tags: ['古装', '权谋', '剧情'], updateInfo: '全54集',
    },
    {
      id: 22, title: '锦月如歌', slug: 'jinyueruge', category: '电视剧', categorySlug: 'dianshiju',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20romance%20drama%20poster%2C%20couple%20in%20ancient%20costumes%20under%20blossoms%2C%20romantic%2C%20no%20text&width=600&height=800&seq=related-2c&orientation=portrait',
      rating: 8.1, year: 2026, description: '女扮男装的将军之女与冷漠王爷的甜蜜爱恋...', tags: ['古装', '爱情', '剧情'], updateInfo: '更新至第42集',
    },
    {
      id: 24, title: '人世间2', slug: 'renshijian2', category: '电视剧', categorySlug: 'dianshiju',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20family%20drama%20poster%2C%20multigenerational%20family%2C%20warm%20home%2C%20nostalgic%2C%20no%20text&width=600&height=800&seq=related-2d&orientation=portrait',
      rating: 9.1, year: 2026, description: '周家三代人的命运在改革开放的浪潮中起伏...', tags: ['剧情', '家庭', '年代'], updateInfo: '更新至第30集',
    },
  ],
  kuangbiao2: [
    {
      id: 3, title: '狂飙2：暗流', slug: 'kuangbiao2', category: '电视剧', categorySlug: 'dianshiju',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20poster%2C%20men%20in%20suits%20in%20night%20city%2C%20rainy%20street%2C%20intense%2C%20no%20text&width=600&height=800&seq=related-3a&orientation=portrait',
      rating: 9.0, year: 2026, description: '扫黑除恶深入，聚焦金融犯罪与网络黑产...', tags: ['犯罪', '悬疑', '剧情'], updateInfo: '更新至第24集',
    },
    {
      id: 13, title: '漫长的季节', slug: 'manchangdejijie', category: '电视剧', categorySlug: 'dianshiju',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20mystery%20drama%20poster%2C%20autumn%20leaves%20in%20old%20town%2C%20nostalgic%20golden%20light%2C%20no%20text&width=600&height=800&seq=related-3b&orientation=portrait',
      rating: 9.4, year: 2023, description: '一座北方小城，一桩跨越二十年的悬案...', tags: ['悬疑', '剧情', '家庭'], updateInfo: '全12集',
    },
    {
      id: 23, title: '破冰行动2', slug: 'pobingxingdong2', category: '电视剧', categorySlug: 'dianshiju',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20action%20drama%20poster%2C%20police%20raid%20scene%2C%20intense%20underground%2C%20no%20text&width=600&height=800&seq=related-3c&orientation=portrait',
      rating: 8.3, year: 2026, description: '缉毒警察深入金三角，揭开跨国毒品交易网络...', tags: ['犯罪', '动作', '剧情'], updateInfo: '更新至第16集',
    },
    {
      id: 21, title: '县委大院2', slug: 'xianweidayuan2', category: '电视剧', categorySlug: 'dianshiju',
      image: 'https://readdy.ai/api/search-image?query=Chinese%20political%20drama%20poster%2C%20government%20office%2C%20serious%20realistic%20style%2C%20no%20text&width=600&height=800&seq=related-3d&orientation=portrait',
      rating: 8.4, year: 2026, description: '光明县新一任领导班子面对乡村振兴的新挑战...', tags: ['剧情', '政治', '现实'], updateInfo: '更新至第18集',
    },
  ],
};